export const SPORTS_COLLECTIONS = ['nfl', 'ncaam', 'ncaaw', 'tennis']; 